import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ClosedNavigationItem } from '../navigation.types';
import { MenuService } from 'src/app/_provider/menu.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';

@Component({
    selector: 'closed-menu',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './closed-menu.component.html',
    styleUrls: ['./closed-menu.component.scss'],
    standalone: false
})
export class ClosedMenuComponent implements OnInit {

  @Input() menuOpen: boolean = true
  @Input() items: ClosedNavigationItem[] = []
  @Input() activatedPage: string = "tabs/home"

  constructor(
    public menuSrv: MenuService,
    public resizeManager: ResizeManagerService
  ) { }

  ngOnInit() {}

}
